import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { switchMap, map } from 'rxjs/operators';
import { ELearningManagementService } from '../e-learning-management.service';
import { saveAs } from 'file-saver/dist/FileSaver';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-assignment-management',
  templateUrl: './assignment-management.component.html',
  styleUrls: ['./assignment-management.component.scss']
})
export class AssignmentManagementComponent implements OnInit {

  assignmentId: string;
  assignment = [];
  detailAllAssignment;
  DetailAssignment: FormGroup;
  isLoading: boolean = false;
  upLoadFile: string;
  sended;
  assignmentName = [];
  courseName = [];
  courseNumber = [];

  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private eLearningService: ELearningManagementService,
    private gobalFunctionService: GobalFunctionService

  ) {
    this.DetailAssignment = this.fb.group({
      feedbackMessage: ['', Validators.required],
      feedbackDoc: [''],
    })
  }

  ngOnInit(): void {
    this.assignmentId = new URL(location.href).searchParams.get('assignmentId');
    this.gobalFunctionService.setTitle('การจัดการ Assignment');

    this.eLearningService.getDetailReceiveAssignmentById(this.assignmentId).pipe(
      switchMap(res => {
        this.detailAllAssignment = res.result;

        return this.eLearningService.getDetailSendedAssignmentById(this.assignmentId).pipe(
          map(res2 => {
            this.sended = res2.result;
          })
        )
      })
    ).subscribe();
  }

  downloadAssignment(url, filename): void {
    saveAs(url, filename);
  }

  callBackFeedBack(feedback, feedbackId) {
    let body;
    this.isLoading = true;
    // console.log(feedback);
    // console.log(feedbackId);

    if (!feedback.feedbackDoc) {
      body = {
        ASSIGNMENT_ID: this.assignmentId,
        FEEDBACK_MESSAGE: feedback.feedbackMessage,
        FROM_FEEDBACK_ID: feedbackId
      }
    } else {
      body = {
        ASSIGNMENT_ID: this.assignmentId,
        FEEDBACK_MESSAGE: feedback.feedbackMessage,
        FEEDBACK_DOC: feedback.feedbackDoc,
        FROM_FEEDBACK_ID: feedbackId
      }
    }

    return this.eLearningService.callBackReceiveAssignmentById(body).subscribe(res => {
      if (res.success) {
        this.isLoading = false;
        location.reload();
      }
    });
  }

  selectFile(e, DetailAssignment) {
    const fileType = this.gobalFunctionService.getTypeFile(e.target.files[0]);

    if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv') {
      if (e.target.files && e.target.files[0]) {
        this.upLoadFile = e.target.files[0].name;

        DetailAssignment.patchValue({
          feedbackDoc: e.target.files[0]
        });
        DetailAssignment.get('feedbackDoc').updateValueAndValidity()

      }
    } else {
      alert('การอัปโหลดเอกสารรองรับไฟล์ CSV, XLSX, PDF, DOC, DOCX เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  collapseCard(form) {
    form.reset();
  }
}

